import * as yup from 'yup'

// O que a norma precisa declarar para entrar no acervo.
//
// Só o que o documento não diz sobre si. Como ele se divide é detectado do
// próprio texto; a quem ele se aplica, não — a capa de uma lei estadual às
// vezes é só o brasão, e adivinhar erra calado: norma de um lugar marcada de
// nacional passa a concorrer em prova do país inteiro, e nada no resultado da
// busca diz que ela não deveria estar ali.
export const legalDocumentSchema = yup.object({
	file: yup.mixed().required('Envie o arquivo da norma'),

	// Opcional: em branco, o acervo lê a citação que o documento imprime na
	// abertura. Só a norma sem número impresso volta pedindo o título.
	title: yup.string().max(255, 'A citação passa de 255 caracteres'),

	nicknames: yup.string(),

	scopes: yup.string(),

	sourceUrl: yup
		.string()
		.url('O endereço precisa ser uma URL completa, começando com https://'),
})
